import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import TranslationUtil from '../../../utils/TranslationUtil';
import { UserCtx } from '../../../contexts/user';

export function PaperContractDisclaimer({
    disclaimerText
}) {
    const { paperContractUser } = useContext(UserCtx);

    return (
        <div>
            { paperContractUser && (
                <p className="property_details__paper-contract-disclaimer">
                    { disclaimerText }
                </p>
            )}
        </div>
    );
}

PaperContractDisclaimer.propTypes = {
    disclaimerText: PropTypes.string.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app } = state;
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    return {
        disclaimerText: translations.getTranslation('property.paperContractDisclaimer')
    };
};

export default connect(mapStateToProps)(PaperContractDisclaimer);
